import { formatDateTime } from 'utils/util'
import { useParams } from 'react-router-dom'
import { Page } from 'components/Shared/Page'
import { ActivityIndicator } from 'components/Shared/ActivityIndicator'
import { useGetRewardProgramById } from 'hooks/api/useGetRewardProgramById'
import { Box, Typography } from '@mui/material'
import { useGetRewardProgramActivityLogByRewardProgramId } from 'hooks/api/useGetRewardProgramActivityLogByRewardProgramId'
import { type GridColDef } from '@mui/x-data-grid'
import { type components } from 'src/api/playerPayback/api'
import { DataTable } from 'components/Shared/DataTable'
import { useLayout } from 'hooks/useLayout'
import { RewardProgramDetailHeader } from '../RewardsProgramDetailsHeader/RewardProgramDetailHeader'

const getColumns = (
  isMobile: boolean
): Array<
  GridColDef<components['schemas']['FullRewardsProgramsActivityLogDTO']>
> => [
  {
    field: 'description',
    headerName: 'Description',
    width: 800,
  },
  {
    field: 'createdBy',
    headerName: 'Updated By',
    valueGetter: (params) => {
      const createdBy = params.row.createdBy
      return createdBy === 'JJVentures.PlayerPAYBACK.WebApi' ? '' : createdBy
    },
    width: 300,
  },
  {
    field: 'createdOn',
    headerName: 'Timestamp',
    valueFormatter: (params: { value: string }) => {
      const date = formatDateTime(params.value, 'MM-dd-yyyy p')
      return isMobile ? `Date: ${String(date)}` : date
    },
    width: 260,
  },
]

export const RewardProgramActivityLogPage = () => {
  const { id: rewardProgramId } = useParams()
  const rewardProgramQuery = useGetRewardProgramById(Number(rewardProgramId))

  const { isMobile } = useLayout()
  const activityLogQuery = useGetRewardProgramActivityLogByRewardProgramId(
    Number(rewardProgramId)
  )
  if (activityLogQuery.isPending || rewardProgramQuery.isPending) {
    return <ActivityIndicator size="fullPage" />
  }

  if (rewardProgramQuery.isError || activityLogQuery.isError) {
    return <p>An error occurred.</p>
  }

  return (
    <Page
      header={
        <RewardProgramDetailHeader
          rewardProgram={rewardProgramQuery.data}
          currentTab={`/Rewards/RewardPrograms/${Number(
            rewardProgramId
          )}/ActivityLog`}
        />
      }
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          rowGap: { xs: '8px', sm: '24px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            width: '100%',
            justifyContent: { xs: 'start', sm: 'space-between' },
            alignItems: { xs: 'start', sm: 'center' },
            rowGap: '8px',
          }}
        >
          <Box>
            <Typography variant={'h2'}>Activity Log</Typography>
          </Box>
        </Box>
        {activityLogQuery.isPending ? (
          <ActivityIndicator size="fullPage" />
        ) : (
          <DataTable
            columns={getColumns(isMobile)}
            rows={activityLogQuery.data ?? []}
            noDataMessage="No activity log data to date."
            sortFieldName="createdOn"
            sort="desc"
          />
        )}
      </Box>
    </Page>
  )
}
